import React from 'react';
import ThemedText from '@portal/components/ThemedText/ThemedText';

import './AdvancedTabs.less';

export interface TabItem {
  key: string;
  label: string;
  children: React.ReactNode;
  disabled?: boolean;
}

interface AdvancedTabsProps {
  items: TabItem[];
  activeKey: string;
  onChange: (key: string) => void;
  className?: string;
}

const AdvancedTabs = ({
  items,
  activeKey,
  onChange,
  className = '',
}: AdvancedTabsProps) => {
  return (
    <div className={`advanced-tabs ${className}`}>
      <div className="advanced-tabs__header">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`advanced-tabs__tab ${
              activeKey === item.key ? 'advanced-tabs__tab--active' : ''
            } ${item.disabled ? 'advanced-tabs__tab--disabled' : ''}`}
            onClick={() => !item.disabled && onChange(item.key)}
            disabled={item.disabled}
          >
            <ThemedText
              variant="body"
              style={{
                marginBottom: '0px',
              }}
              fontWeight={activeKey === item.key ? 'semiBold' : 'regular'}
              color={activeKey === item.key ? 'primary' : 'gray'}
            >
              {item.label}
            </ThemedText>
          </button>
        ))}
      </div>
      <div className="advanced-tabs__content">
        {items.find((item) => item.key === activeKey)?.children}
      </div>
    </div>
  );
};

export default AdvancedTabs;
